import { __extends, __rest, __assign } from 'tslib';
import React__default, { Component } from 'react';
import clsx from 'clsx';
import ButtonBase from '../ButtonBase/ButtonBase.component.js';
import ButtonLoader from '../ButtonLoader/ButtonLoader.component.js';
import { propTypes, defaultProps } from './Button.types.js';
import styles from './Button.module.scss.js';

/**
 * Main button component.
 *
 * Can be either primary, secondary or tertiary,
 * full-width or content-width.
 * Can contain icons.
 */
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.typeClasses = {
            primary: 'PrimaryButton',
            secondary: 'SecondaryButton',
            tertiary: 'TertiaryButton',
            ghost: 'GhostButton',
        };
        return _this;
    }
    Button.prototype.componentDidMount = function () {
        if (this.props.testId) {
            console.warn('DEPRECATION WARNING: The `testId` prop is deprecated and support for it will be removed soon. Please use `data-testid` instead.');
        }
        if (this.props.styling) {
            console.warn('DEPRECATION WARNING: The `styling` prop is deprecated and support for it will be removed soon. Please use `variant` instead.');
        }
        if (this.props.v2) {
            console.warn('DEPRECATION WARNING: The `v2` prop is deprecated and support for it will be removed soon.');
        }
    };
    Button.prototype.getClassNames = function (props) {
        var styling = props.styling, variant = props.variant, danger = props.danger, block = props.block, className = props.className, isLoading = props.isLoading, disabled = props.disabled;
        var variantClass = this.typeClasses[styling || variant];
        return clsx(styles.Button, styles[variantClass], danger && styles[variantClass + "___danger"], disabled && !isLoading && styles[variantClass + "___disabled"], block && styles.Button___block, isLoading && styles.Button___loading, className);
    };
    Button.prototype.render = function () {
        var _a = this.props, children = _a.children, testId = _a.testId, disabled = _a.disabled, isLoading = _a.isLoading, 
        /* we take out properties that are used only for classes creation */
        /* eslint-disable @typescript-eslint/no-unused-vars */
        variant = _a.variant, styling = _a.styling; _a.className; _a.block; var danger = _a.danger; _a.v2; var onClick = _a.onClick, restProps = __rest(_a, ["children", "testId", "disabled", "isLoading", "variant", "styling", "className", "block", "danger", "v2", "onClick"]);
        return (React__default.createElement(ButtonBase, __assign({ "data-testid": this.props['data-testid'] || testId, className: this.getClassNames(this.props), disabled: disabled && !isLoading, onClick: onClick }, restProps),
            isLoading && (React__default.createElement(ButtonLoader, { variant: styling || variant, danger: danger, "data-testid": this.props['data-testid'] || testId })),
            children));
    };
    Button.displayName = 'Button';
    Button.propTypes = propTypes;
    Button.defaultProps = __assign({}, defaultProps);
    return Button;
}(Component));

export { Button, Button as default };
